
/**
 * Created by Rick on 10/20/2023.
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EditRelationshipService {
    dialogClose$: Subject<any> = new Subject<any>();
    dialogOpen$: Subject<any> = new Subject<any>();
    feedbackSubject$: Subject<any> = new Subject<any>();
}
